import * as React from 'react';
import {
	prettifyImgUrl,
	prettifyRichText,
} from '../../../../ta-services/ta-utils';

type TaResultDetailsCardProps = {
	topic: string;
	text: string;
	icon: string;
};

export const TaResultDetailsCard = ({
	topic,
	text,
	icon,
}: TaResultDetailsCardProps) => {

	const renderCardText = (richText: string, textType: string) => {
		if (textType === 'p') {
			return prettifyRichText(richText)
				.filter((textline: string) => textline[0] !== '-')
				.map((textline: string, idx: number) => {
					return <p key={idx}>{textline}</p>;
				});
		}
		if (textType === 'li') {
			return prettifyRichText(richText)
				.filter((textline: string) => textline[0] === '-')
				.map((textline: string, idx: number) => {
					return <li key={idx}>{textline.replace('-', '')}</li>;
				});
		}
	};

	return (
		<div className='ta-result-details-card_container'>
			<div className='ta-result-details-card_icon'>
				<img src={prettifyImgUrl(icon)} alt='' />
			</div>
			<div className='ta-result-details-card_title'>{topic}</div>
			<div className='ta-result-details-card_text'>
				{renderCardText(text, 'p')}
				{<ul>{renderCardText(text, 'li')}</ul>}
			</div>
		</div>
	);
};
